// src/hooks/useTheme.ts
import { useEffect } from "react";
import { useAppStore } from "../store/app.store";

export const useTheme = () => {
  const { theme, toggleTheme, setTheme } = useAppStore();

  useEffect(() => {
    // Remove both theme classes and add the current one
    const root = document.documentElement;
    root.classList.remove("light-theme", "dark-theme");
    root.classList.add(`${theme}-theme`);

    // Update meta theme-color
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute(
        "content",
        theme === "light" ? "#fef9f7" : "#1e1c1a",
      );
    }
  }, [theme]);

  return {
    theme,
    toggleTheme,
    setTheme,
    isLight: theme === "light",
    isDark: theme === "dark",
  };
};
